import { render, staticRenderFns } from "./ProductCardAccordion.vue?vue&type=template&id=4ac0ca9c&"
import script from "./ProductCardAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductCardAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports